class OrderHelper {
  constructor() { }

  /**
     * Заполняет шаблон билета данными
     * @param $ticket
     * @param data {Object} - {
     *   sector or view_id,
     *   sid or id,
     *   event_id,
     *   row,
     *   col,
     *   price
     * }

     */

  insertDataToTicket($ticket, data) {
    const sector = data.sector || '';
    const sid = data.sid || data.id;
    const currentEventId = data.event_id;
    const priceId = data.price_view_id || data.price_id;
    const name = data.name || `Ряд ${data.row} место ${data.col}`;
    const ticketClassName = null;
    $ticket.find('.js-ticket-price').text(data.price !== undefined ? data.price : '');
    $ticket.find('.js-ticket-sector').text(sector);
    !data.is_pack && !data.hide ? $ticket.find('.js-ticket-place').text(name) : '';
    data.is_pack && data.hide && sector !== 'Ресторан' ? '' : $ticket.find('.js-ticket-place').text(name);

    $ticket
      .find('.tickets__item')
      .attr('data-place', sid)
      .attr('data-uid', data.uid)
      .attr('data-id', data.id)
      .attr('data-price-id', priceId)
      .attr('data-event', currentEventId)
      .addClass(ticketClassName);

    return $ticket;
  }
}

export const orderHelper = new OrderHelper();
